/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  TableAccountability,
  ShadowTableColumn,
  TableAverage,
  TeamAverageRow,
  StickyTableHead,
  ShadowSummaryColumn,
  ArrowHolderSummary,
  ColumnContainerSummary,
} from './styles';
import { SelectPlayerColumn } from '..';
import { Utils } from '../../utils/api';
import { GoChevronDown, GoChevronUp } from 'react-icons/go';

export default ({
  dataTableContent,
  teamAverage,
  dataCy,
  minWidth,
  filter,
  handleSort,
  sortBy,
  sortOrder,
}: {
  dataTableContent: Array<any>;
  teamAverage: any;
  dataCy?: string;
  minWidth?: string;
  filter: string;
  handleSort: (key: string) => void;
  sortBy: string;
  sortOrder: string;
}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [reverse, useReverse] = useState<boolean>(false);

  const sortOptions = [!reverse, changeTable, table];
  const UTILS = new Utils();

  useEffect(() => {
    useTable(dataTableContent);
  }, [dataTableContent]);

  function changeTable(e) {
    useTable([...e]);
  }

  function toggleSortString(sort, params) {
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }

  function toggleSortNumber(sort, params) {
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }

  function sortingTableHead(title: string = '', attr: string, location: Array<string>, sortFunction) {
    return (
      <StickyTableHead topPosition="141px" onClick={() => sortFunction(attr, location)} topPositionResponsive="41px">
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sortBy === attr && sortOrder === 'desc' && <GoChevronDown size={14} />}
            {sortBy === attr && sortOrder === 'asc' && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickyTableHead>
    );
  }

  return (
    <TableAccountability data-cy={dataCy} minWidth={minWidth}>
      <thead>
        <tr>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px">
            PLAYERS
          </StickyTableHead>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px" colSpan={5}>
            ACCOUNTABILITY
          </StickyTableHead>
          <StickyTableHead topPosition="100px" topPositionResponsive="0px" colSpan={5}>
            LAST 7 DAYS
          </StickyTableHead>
        </tr>
        <tr>
          {sortingTableHead('Name', 'firstName', ['firstName'], handleSort)}
          {sortingTableHead('Current Streak', 'currentStreak', ['summary', 'currentStreak'], toggleSortNumber)}
          {sortingTableHead('Last 7 Days', 'last7Days', ['summary', 'last7Days'], toggleSortNumber)}
          {sortingTableHead('Longest Streak', 'longestStreak', ['summary', 'longestStreak'], toggleSortNumber)}
          {sortingTableHead('Total Sessions', 'totalSessions', ['summary', 'totalSessions'], toggleSortNumber)}
          {sortingTableHead('Current Emphasis', 'currentEmphasis', ['summary', 'currentEmphasis'], toggleSortString)}
          {sortingTableHead('Prep', 'prep', ['summary', 'prep'], toggleSortNumber)}
          {sortingTableHead('Recovery', 'recovery', ['summary', 'recovery'], toggleSortNumber)}
          {sortingTableHead('Strength', 'strength', ['summary', 'strength'], toggleSortNumber)}
          {sortingTableHead('Hybrid', 'hybrid', ['summary', 'hybrid'], toggleSortNumber)}
          {sortingTableHead('Off Days', 'offDays', ['summary', 'offDays'], toggleSortNumber)}
        </tr>
      </thead>
      <tbody>
        {table.length > 0 && (
          <TeamAverageRow>
            <td>
              <TableAverage>Team Average</TableAverage>
            </td>
            <td>{teamAverage?.training?.currentStreakAvg || '-'}</td>
            <td>{teamAverage?.training?.last7DaysAvg || '-'}</td>
            <td>{teamAverage?.training?.longestStreakAvg || '-'}</td>
            <td>{teamAverage?.training?.totalSessionsAvg || '-'}</td>
            <td>{'-'}</td>
            <ShadowSummaryColumn>{teamAverage?.training?.prepAvg || '-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{teamAverage?.training?.recoveryAvg || '-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{teamAverage?.training?.strengthAvg || '-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{teamAverage?.training?.hybridAvg || '-'}</ShadowSummaryColumn>
            <ShadowSummaryColumn>{teamAverage?.training?.offDaysAvg || '-'}</ShadowSummaryColumn>
          </TeamAverageRow>
        )}
        {table?.length > 0 ? (
          table
            .filter(el => {
              const playerName: string = el.firstName || '';
              const playerLast: string = el.lastName || '';
              const name = `${playerName} ${playerLast}`;
              return name.toLocaleLowerCase().includes(filter.toLowerCase());
            })
            ?.map((item, index) => {
              return (
                <tr key={index}>
                  <SelectPlayerColumn player={item} />
                  <td>{(item.summary?.currentStreak !== undefined ||item.summary?.currentStreak !== null) ? item.summary?.currentStreak : '-'}</td>
                  <td>{(item.summary?.last7Days !== undefined ||item.summary?.last7Days !== null) ? item.summary?.last7Days : '-'}</td>
                  <td>{(item.summary?.longestStreak !== undefined ||item.summary?.longestStreak !== null) ? item.summary?.longestStreak : '-'}</td>
                  <td>{(item.summary?.totalSessions !== undefined ||item.summary?.totalSessions !== null) ? item.summary?.totalSessions : '-'}</td>
                  <td>{(item.summary?.currentEmphasis !== undefined ||item.summary?.currentEmphasis !== null) ? item.summary?.currentEmphasis : '-'}</td>
                  <ShadowTableColumn>{(item.summary?.prep !== undefined ||item.summary?.prep !== null) ? item.summary?.prep : '-'}</ShadowTableColumn>
                  <ShadowTableColumn>{(item.summary?.recovery !== undefined ||item.summary?.recovery !== null) ? item.summary?.recovery : '-'}</ShadowTableColumn>
                  <ShadowTableColumn>{(item.summary?.strength !== undefined ||item.summary?.strength !== null) ? item.summary?.strength : '-'}</ShadowTableColumn>
                  <ShadowTableColumn>{(item.summary?.hybrid !== undefined ||item.summary?.hybrid !== null) ? item.summary?.hybrid : '-'}</ShadowTableColumn>
                  <ShadowTableColumn>{(item.summary?.offDays !== undefined ||item.summary?.offDays !== null) ? item.summary?.offDays : '-'}</ShadowTableColumn>
                </tr>
              );
            })
        ) : (
          <tr>
            <td colSpan={11}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableAccountability>
  );
};
